import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { NumperInputProps } from './Types';
import InputLabel from './InputLabel';

const RangeNumberInput: React.FC<NumperInputProps> = ({
  label,
  shape = 'squre',
  color = 'textPrimary',
  bg = 'white',
  onChange,
  name,
  required = false,
  value,
  placeholder = 'Start number, End number',
  max,
  min,
}) => {
  const values = value?.toString().split(', ');
  const placeholders = placeholder?.split(', ');

  const [startNumber, setStartNumber] = useState<string | undefined>(
    values && values[0]
  );
  const [endNumber, setEndNumber] = useState<string | undefined>(
    values && values[1]
  );

  const { t } = useTranslation();

  useEffect(() => {
    onChange(name, `${startNumber}, ${endNumber}`);
  }, [startNumber, endNumber]);

  return (
    <div>
      {label && <InputLabel text={label} name={name} required={required} />}
      <div
        className={`relative  ${
          shape === 'circle' ? 'rounded-full' : 'rounded-md'
        } flex justify-between items-center`}
      >
        <input
          type="number"
          max={max}
          min={min}
          id={name}
          value={startNumber || ''}
          required={required}
          onChange={(event) => setStartNumber(event.target.value)}
          className={`input focus:ring-ring-color w-36 shadow-sm focus:ring-4 cursor-pointer  focus:ring-opacity-10 focus:ring-offset-0  ${
            shape === 'circle' ? 'rounded-full' : 'rounded-md'
          } bg-${bg} text-${color} focus:border-primary block sm:text-sm border-gray-300 `}
          placeholder={
            t(
              `inputs.placeholders.${placeholders[0]}`,
              placeholders[0] || ''
            ) as string
          }
        />
        <input
          type="number"
          max={max}
          min={min}
          id={name}
          value={endNumber || ''}
          required={required}
          onChange={(event) => setEndNumber(event.target.value)}
          className={`focus:ring-ring-color w-36 shadow-sm focus:ring-4 cursor-pointer  focus:ring-opacity-10 focus:ring-offset-0  ${
            shape === 'circle' ? 'rounded-full' : 'rounded-md'
          } bg-${bg} text-${color} focus:border-primary block sm:text-sm border-gray-300 `}
          placeholder={
            t(
              `inputs.placeholders.${placeholders[1]}`,
              placeholders[1] || ''
            ) as string
          }
        />
      </div>
    </div>
  );
};

export default RangeNumberInput;
